// src/PreventUnmounting.tsx
import Box from "@mui/joy/Box";
import { jsx } from "react/jsx-runtime";
var PreventUnmounting = (props) => {
  return /* @__PURE__ */ jsx(Box, { sx: { display: props.show ? "block" : "none" }, children: props.children });
};
var PreventUnmounting_default = PreventUnmounting;

export {
  PreventUnmounting_default
};
